import { render, staticRenderFns } from "./viewallNews.vue?vue&type=template&id=286a8d43&scoped=true"
import script from "./viewallNews.vue?vue&type=script&lang=js"
export * from "./viewallNews.vue?vue&type=script&lang=js"
import style0 from "./viewallNews.vue?vue&type=style&index=0&id=286a8d43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286a8d43",
  null
  
)

export default component.exports